// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"260":"308c7c4667","371":"fd4baeb0f8","701":"34175a0d26","765":"3558d7fecf"}[chunkId] + ".css";
};